import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const ProductDesign = () => {
  useEffect(() => {
    // Scroll-based navigation highlighting
    const sections = document.querySelectorAll(".tab-data[id]");
    const navLinks = document.querySelectorAll(".nav-selector a");

    const navHighlighter = () => {
      let scrollY = window.pageYOffset;

      sections.forEach((current) => {
        const sectionHeight = current.offsetHeight;
        const sectionTop =
          current.getBoundingClientRect().top + window.pageYOffset - 50;
        const sectionId = current.getAttribute("id");

        if (scrollY > sectionTop && scrollY <= sectionTop + sectionHeight) {
          navLinks.forEach((link) => {
            link.parentElement.classList.remove("active");
            if (link.getAttribute("href") === `#${sectionId}`) {
              link.parentElement.classList.add("active");
            }
          });
        }
      });
    };

    window.addEventListener("scroll", navHighlighter);
    return () => window.removeEventListener("scroll", navHighlighter);
  }, []);

  return (
    <div className="product-design-page">
      <section className="banner-section">
        <div className="intro">
          <div className="intro-bg wow fadeIn" data-wow-delay="0.3s">
            <img
              src="/assets/images/background/intro-bg.jpg"
              alt="Light Background"
            />
          </div>
          <div className="container">
            <h1 className="wow fadeInUp" data-wow-delay="0.3s">
              Product Design
            </h1>
          </div>
        </div>
      </section>

      <section className="top-services-section">
        <div className="container">
          <div className="title">
            <h2 className="wow fadeInUp">
              From <span className="gradient-text">Concept to Creation</span>:
              <br /> UI Design Services Deliver Results
            </h2>
            <h3 className="wow fadeInUp">How we work</h3>
            <p className="wow fadeInUp">
              At Slash Star, we know that every detail matters in product design.
              That's why we take a research-driven approach to design, focusing
              on every aspect of the user experience. Our team of designers and
              researchers work together to create interfaces that are not only
              visually appealing but also delightful to use. Our ultimate goal
              is to create innovative and engaging design solutions that meet
              the needs of our clients and their users.
            </p>
          </div>
          <div className="row flex-start wow fadeInUp">
            <div className="col col-4">
              <div className="box">
                <span>01</span>
                <h3>Project Definition</h3>
                <p>
                  We start by understanding your project requirements, goals,
                  and constraints. We collaborate with you to define the project
                  scope, timeline, and budget.
                </p>
              </div>
            </div>
            <div className="col col-4">
              <div className="box">
                <span>02</span>
                <h3>Research</h3>
                <p>
                  Based on the project definition, we conduct research to gain
                  insights into your target audience, market trends, and
                  competitors.
                </p>
              </div>
            </div>
            <div className="col col-4">
              <div className="box">
                <span>03</span>
                <h3>Ideation</h3>
                <p>
                  We generate multiple design concepts based on our research and
                  work collaboratively with you to refine the design concepts
                  until we are on same page.
                </p>
              </div>
            </div>
            <div className="col col-4">
              <div className="box">
                <span>04</span>
                <h3>Prototyping</h3>
                <p>
                  We develop interactive prototypes, which we test with real
                  users to get feedback on the design and identify any usability
                  issues.
                </p>
              </div>
            </div>
            <div className="col col-4">
              <div className="box">
                <span>05</span>
                <h3>Testing & Evaluation</h3>
                <p>
                  We conduct usability testing and evaluate the effectiveness of
                  the design solutions based on the project requirements and
                  user feedback.
                </p>
              </div>
            </div>
            <div className="col col-4">
              <div className="box">
                <span>06</span>
                <h3>Delivery</h3>
                <p>
                  Once the design is finalized, we deliver the final design
                  assets, along with detailed documentation, to ensure a smooth
                  implementation of the design.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="tabs-section">
        <div className="container wow fadeInUp">
          <div className="row">
            <div className="col col-6 nav-selector">
              <div className="title-small">
                <span>SERVICES</span>
              </div>
              <ul>
                <li>
                  <a href="#section1">Logo Design</a>
                </li>
                <li>
                  <a href="#section2">Branding</a>
                </li>
                <li>
                  <a href="#section3">UI UX Design Services</a>
                </li>
                <li>
                  <a href="#section4">Mobile App Design</a>
                </li>
                <li>
                  <a href="#section5">Web App Design</a>
                </li>
              </ul>
            </div>
            <div className="col col-6">
              <div className="tab-data" id="section1">
                <div className="tab-image">
                  <img
                    src="/assets/images/navbar/product-des/product-logo.webp"
                    alt="logo"
                  />
                </div>
                <h3>Logo Design</h3>
                <p>
                  Your logo is the face of your brand. It's the first thing that
                  customers will see and remember about your business. We
                  understand the importance of creating a logo that accurately
                  represents your brand, communicates your message and sets you
                  apart from the competition.
                </p>
                <p>
                  Our team of designers will work closely with you to create a
                  logo that reflects your brand values, vision and personality.
                </p>
              </div>
              <div className="tab-data" id="section2">
                <div className="tab-image">
                  <img
                    src="/assets/images/navbar/product-des/product-branding.webp"
                    alt="Branding"
                  />
                </div>
                <h3>Branding</h3>
                <p>
                  Branding is more than just a logo or a color scheme. It's
                  about creating a unique identity for your business that
                  resonates with your audience. Our branding services cover
                  everything from brand strategy, messaging, visual identity, and
                  more.
                </p>
                <p>
                  We'll help you craft a compelling brand story that resonates
                  with your target audience and helps you stand out in your
                  market.
                </p>
              </div>
              <div className="tab-data" id="section3">
                <div className="tab-image">
                  <img
                    src="/assets/images/navbar/product-des/product-ui.webp"
                    alt="UI UX Design Services"
                  />
                </div>
                <h3>UI UX Design Services</h3>
                <p>
                  User experience (UX) is an essential part of any digital
                  product design. Our team of UI UX designers will work closely
                  with you to understand your business goals and user needs to
                  create intuitive and delightful user experiences. We offer
                  innovative UI UX design services at Slash Star, aimed at
                  delivering an excellent finished product in a timely manner.
                  Through an innovative design process.
                </p>
                <p>
                  Slash Star is a digital product design company well-known as a
                  developer of the award-winning Monument Valley games.
                </p>
              </div>
              <div className="tab-data" id="section4">
                <div className="tab-image">
                  <img
                    src="/assets/images/navbar/product-des/product-mobile.webp"
                    alt="Mobile App Design"
                  />
                </div>
                <h3>Mobile App Design</h3>
                <p>
                  Mobile devices have become an integral part of our daily lives,
                  and mobile apps play a vital role in this. Our mobile app
                  design services cover the entire app design process, from
                  conceptualization to development.
                </p>
                <p>
                  We specialize in creating user centric designs that are easy to
                  use. Our team has extensive experience designing apps for both
                  iOS and Android platforms.
                </p>
              </div>
              <div className="tab-data" id="section5">
                <div className="tab-image">
                  <img
                    src="/assets/images/navbar/product-des/product-web.webp"
                    alt="Web App Design"
                  />
                </div>
                <h3>Web App Design</h3>
                <p>
                  Web apps are the backbone of many businesses today. We
                  understand the importance of creating web apps that are
                  user-friendly, responsive, and visually appealing. Our web app
                  design services cover everything from wireframing to prototyping
                  to visual design.
                </p>
                <p>
                  We'll create responsive web designs that are optimized for user
                  experience and conversion.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="technology-section">
        <div className="container wow fadeInUp">
          <div className="title-small">
            <span>Technology</span>
          </div>
          <div className="title">
            <h2>
              Empowering Your Business with <br />
              Our <span className="gradient-text">Tech Savvy Stack</span>
            </h2>
          </div>
          <div className="flex-start">
            <div className="col">
              <i>
                <img src="/assets/images/icon/icon-figma.svg" alt="Figma" />
              </i>
              <span>Figma</span>
            </div>
            <div className="col">
              <i>
                <img
                  src="/assets/images/icon/icon-adobe-xd.svg"
                  alt="Adobe Xd"
                />
              </i>
              <span>Adobe Xd</span>
            </div>
            <div className="col">
              <i>
                <img
                  src="/assets/images/icon/icon-adobe -illustrator.svg"
                  alt="Adobe Ai"
                />
              </i>
              <span>Adobe Ai</span>
            </div>
            <div className="col">
              <i>
                <img
                  src="/assets/images/icon/icon-adobe-photoshop.svg"
                  alt="Photoshop"
                />
              </i>
              <span>Photoshop</span>
            </div>
            <div className="col">
              <i>
                <img
                  src="/assets/images/icon/icon-after-effects.svg"
                  alt="After Effect"
                />
              </i>
              <span>After Effect</span>
            </div>
            <div className="col">
              <i>
                <img
                  src="/assets/images/icon/icon-balsamiq.svg"
                  alt="Balsamiq"
                />
              </i>
              <span>Balsamiq</span>
            </div>
            <div className="col">
              <i>
                <img src="/assets/images/icon/icon-miro.svg" alt="Miro" />
              </i>
              <span>Miro</span>
            </div>
            <div className="col">
              <i>
                <img src="/assets/images/icon/icon-zeplin.svg" alt="Zeplin" />
              </i>
              <span>Zeplin</span>
            </div>
            <div className="col">
              <i>
                <img src="/assets/images/icon/icon-sketch.svg" alt="Sketch" />
              </i>
              <span>Sketch</span>
            </div>
            <div className="col">
              <i>
                <img
                  src="/assets/images/icon/icon-invision.svg"
                  alt="Invision"
                />
              </i>
              <span>Invision</span>
            </div>
          </div>
        </div>
      </section>

      <section className="approach-section">
        <div className="container wow fadeInUp">
          <div className="title-small">
            <span>Why Us</span>
          </div>
          <div className="title">
            <h2>
              The Benefits of <span className="gradient-text">Partnering</span>{" "}
              with Us
            </h2>
          </div>
          {/* Desktop */}
          <div className="why-us-content why-us-desktop wow fadeInUp">
            <div className="why-us-datas">
              <div>
                <h3>World class team</h3>
                <p>
                  With our end-to-end design expertise, we can handle every aspect
                  of your project from start to finish, ensuring a cohesive and
                  user-friendly design.
                </p>
              </div>
              <div>
                <h3>Lean UX approach</h3>
                <p>
                  Our lean UX approach prioritizes user needs and feedback,
                  resulting in a streamlined design process that delivers maximum
                  value with minimal waste.
                </p>
              </div>
              <div>
                <h3>Curiosity</h3>
                <p>
                  Our curiosity drives us to ask the right questions, identify
                  opportunities, and create solutions that meet your unique
                  business needs.
                </p>
              </div>
            </div>
            <div className="why-us-datas">
              <div>
                <h3>Rapid Results</h3>
                <p>
                  We deliver rapid results without sacrificing quality, using
                  agile methodologies and efficient design processes to ensure
                  timely delivery of high-quality designs.
                </p>
              </div>
              <div>
                <h3>Collaborative</h3>
                <p>
                  We believe in working closely with our clients throughout the
                  design process, from ideation to implementation.
                </p>
              </div>
            </div>

            <div className="why-us-datas">
              <div>
                <h3>User centric</h3>
                <p>
                  Our user-centric approach ensures that your users can easily
                  navigate your website or application, resulting in increased
                  engagement and conversions.
                </p>
              </div>
            </div>
          </div>
          {/* Mobile */}
          <div className="why-us-content why-us-mobile wow fadeInUp">
            <div>
              <h3>World class team</h3>
              <p>
                With our end-to-end design expertise, we can handle every aspect
                of your project from start to finish, ensuring a cohesive and
                user-friendly design.
              </p>
            </div>
            <div>
              <h3>Lean UX approach</h3>
              <p>
                Our lean UX approach prioritizes user needs and feedback,
                resulting in a streamlined design process that delivers maximum
                value with minimal waste.
              </p>
            </div>
            <div>
              <h3>Curiosity</h3>
              <p>
                Our curiosity drives us to ask the right questions, identify
                opportunities, and create solutions that meet your unique
                business needs.
              </p>
            </div>
            <div>
              <h3>Rapid Results</h3>
              <p>
                We deliver rapid results without sacrificing quality, using agile
                methodologies and efficient design processes to ensure timely
                delivery of high-quality designs.
              </p>
            </div>
            <div>
              <h3>Collaborative</h3>
              <p>
                We believe in working closely with our clients throughout the
                design process, from ideation to implementation.
              </p>
            </div>
            <div>
              <h3>User centric</h3>
              <p>
                Our user-centric approach ensures that your users can easily
                navigate your website or application, resulting in increased
                engagement and conversions.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="portfolio-section projects-section">
        <div className="container">
          <h2>More Projects</h2>
          <div className="portfolio card-deck-js">
            <div className="portfolio-card">
              <Link to="/finutss">
                <div className="portfolio-product">
                  <div className="product-image">
                    <img
                      src="/assets/images/protfolio/finutz.svg"
                      alt="Finutss"
                    />
                  </div>
                  <div className="product-content">
                    <div className="product-data">
                      <h3>Finutss</h3>
                      <div>
                        <span>iOS</span>
                        <span>Android</span>
                      </div>
                    </div>
                    <div className="product-url">
                      <img src="/assets/images/icon/arrow.svg" alt="arrow-1" />
                    </div>
                  </div>
                </div>
              </Link>
              <Link to="/bullz">
                <div className="portfolio-product">
                  <div className="product-image">
                    <img src="/assets/images/protfolio/bullz.svg" alt="bullz" />
                  </div>
                  <div className="product-content">
                    <div className="product-data">
                      <h3>Bullz</h3>
                      <div>
                        <span>iOS</span>
                        <span>Android</span>
                      </div>
                    </div>
                    <div className="product-url">
                      <img src="/assets/images/icon/arrow.svg" alt="arrow-2" />
                    </div>
                  </div>
                </div>
              </Link>
              <Link to="/telly">
                <div className="portfolio-product">
                  <div className="product-image">
                    <img src="/assets/images/protfolio/telly.svg" alt="Telly" />
                  </div>
                  <div className="product-content">
                    <div className="product-data">
                      <h3>Telly</h3>
                      <div>
                        <span>Web</span>
                        <span>iOS</span>
                        <span>Android</span>
                      </div>
                    </div>
                    <div className="product-url">
                      <img src="/assets/images/icon/arrow.svg" alt="arrow-3" />
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ProductDesign;
